import { keyframes, styled } from "styled-components";

import { zIndex } from "common/constants/zIndex";

const BriefingProgress = styled.div`
  position: relative;
  margin-top: 10px;
  background: ${({ theme }) => theme.colors.progressBarBackground};
  border-radius: 12px;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.progressBarBorder};
  padding: 1px;
  overflow: hidden; /* Important: prevents shimmer from showing outside bounds */
`;

const BriefingProgressText = styled.span`
  color: white;
  position: absolute;
  left: 50%;
  top: 3px;
  transform: translate(-50%);
  white-space: nowrap;
  z-index: ${zIndex.progressBarText};
`;

const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(200%);
  }
`;

const BriefingProgressLoaded = styled.div`
  position: relative;
  background: ${({ theme }) => theme.colors.blue};
  border-radius: 10px;
  transition: width 1s;
  height: 24px;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.3) 30%,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0.3) 70%,
      transparent 100%
    );
    width: 50%;
    animation: ${shimmer} 2s linear infinite;
  }
`;

type ProgressBarProps = { percentage: number; text: string };

export const ProgressBar = ({ percentage, text }: ProgressBarProps) => (
  <BriefingProgress>
    <BriefingProgressLoaded style={{ width: `${percentage}%` }} />
    <BriefingProgressText>{text}</BriefingProgressText>
  </BriefingProgress>
);
